module.exports = __webpack_public_path__ + "static/media/portfolio1 (21).0e355952.jpeg";